<appTable v-if="shouldRenderConfig" :tableName="name"  v-bind:tableClass="getClassName">
    <slot></slot>
    <div class="quantityFileCopy">
        <span>{{$t('Send +1 copy elsewhere')}}</span>
        <input type="checkbox" v-model="fileCopy"/>
    </div>
</appTable>